import React from "react";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import "./manufacturing.css";
import KeyChallenges from "./KeyChallenges";
import KeyFeatures from "./KeyFeatures";
import HowItWorks from "./HowItWorks";
import TechnologyStack from "./TechnologyStack";
import CallToAction from "./CallToAction";
import Benefits from "./Benefits";

const Manufacturing = () => {
  return (
    <div className="manufacturing-industry-wrapper">
      <Particles title="Manufacturing" />
      <HeroSection />
      <KeyChallenges />
      <KeyFeatures />
      <Benefits />
      <HowItWorks />
      <TechnologyStack />
      <CallToAction />
    </div>
  );
};

export default Manufacturing;
